// A truck only counts as "configured" hardware when its IMEI is a valid 15-digit
// Teltonika IMEI — the same rule the API and the Add-Truck form enforce
// (/^\d{15}$/). Placeholder IMEIs like "PENDING-00000002", "Pending3" or "abc"
// are NOT real devices, even though they're non-empty, so a strict
// present-and-non-empty check is not enough.
//
// `connectivity` is the server-computed signal ('not_configured' | 'never_connected'
// | null). We OR it with the IMEI check so the UI renders muted even if a stale
// ThingsBoard device id is still leaking telemetry that flips `online` true.
export const REAL_IMEI = /^\d{15}$/

export function hasRealDevice(truck) {
  return REAL_IMEI.test(String(truck?.imei || '').trim())
}

// True when the truck has no real hardware behind it and must render muted
// (gray dot, "No device" / "Never connected"), never green/online.
export function isUnconfigured(truck) {
  if (!truck) return true
  if (truck.connectivity === 'not_configured' || truck.connectivity === 'never_connected') return true
  return !hasRealDevice(truck)
}
